export function ContractFactoryHof(web3) {
    return ({
        create: async (abi, address) => {
            return new web3.eth.Contract(abi, address)
        }
    });
}